import { ChangeDetectorRef, Component, Input, OnInit } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { ToastrService } from 'ngx-toastr';
import Swal from 'sweetalert2';

import { PipelineService } from '@app/core/pipelines/services/pipeline.service';
import { RfqService } from '@app/core/quotes';
import { ProductDesignService } from '@app/core/quotes/services/product-design.service';

@Component({
  selector: 'rfq-image-popup',
  templateUrl: './rfq-image-popup.component.html',
  styleUrls: ['./rfq-image-popup.component.scss'],
})
export class RfqImagePopupComponent implements OnInit {
  @Input() imageId :number;
  @Input() skuId :number;

  image :any;
  loading :boolean;

  constructor(
    public rfqService :RfqService,
    public activeModal :NgbActiveModal,
    private toastr :ToastrService,
    private cd :ChangeDetectorRef,
  ) {}

  ngOnInit() {
    console.log(this.imageId);
    this.rfqService.viewImage(this.imageId).subscribe((image :any) => {
      this.image = image;
    });
    this.loading = false;
  }

  deleteImage() {
    Swal.fire({
      title: 'Confirm',
      text: 'Are you sure to delete this image?',
      type: 'warning',
      showCancelButton: true,
      confirmButtonColor: '#3085d6',
      cancelButtonColor: '#d33',
      confirmButtonText: 'Confirm',
    }).then((result) => {
      if (result.value) {
        this.loading = true;
        this.rfqService.deleteImage(this.skuId, this.imageId).subscribe(
          (resp) => {
            this.toastr.success('Image deleted.');
            this.loading = false;
            this.activeModal.dismiss();
          },
          (error) => {
            this.loading = false;
            this.toastr.error(
              'Error when deleting image. Please try again later or contact support.',
            );
            this.cd.detectChanges();
          },
        );
      }
    });
  }
}
